import { useState } from 'react';
import {
  genProxyResource,
  recommendation,
  recommendations
} from 'utilities/api';

// The `recommendation` / `recommendations` resources already route themselves by
// `releaseBeRecommendationsV2` per request, so they are returned as-is; any other
// resource name is generated against Java as before.
const ROUTED_RESOURCES = { recommendation, recommendations };

function useRecommendationsApi(resourceName) {
  const [api] = useState(
    () =>
      ROUTED_RESOURCES[resourceName] ??
      genProxyResource(resourceName, { urlVersion: '/v1' })
  );

  return api;
}

export default useRecommendationsApi;
